/**
 *
 * TopicOptionB
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import _classNames from 'classnames';
import _get from 'lodash/get';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    backgroundColor: '#FFFFFF',
    borderRadius: 18,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: '#ECECEC',
    padding: '7px 20px',
    margin: '5px 10px',
    color: '#4B4B4B',
    cursor: 'pointer',
  },
  bigger: {
    '& > p': {
      fontFamily: 'MadaBold',
    },
  },
  selected: {
    borderColor: '#01619B',
    backgroundColor: '#01619B',
    color: '#FFFFFF',
  },
});

const TopicOptionB = ({ onSelect, selected, data, type }) => {
  const classes = useStyles();

  return (
    <div
      className={_classNames({
        [classes.container]: true,
        [classes.selected]: selected,
        [classes.bigger]: data.userRating > 50,
      })}
      onClick={() => onSelect(type, data)}
      role="button"
      tabIndex={0}
    >
      <Typography variant="body2" align="center">
        {data.title || _get(data, 'fields.title')}
      </Typography>
    </div>
  );
};

TopicOptionB.propTypes = {
  onSelect: PropTypes.func,
  data: PropTypes.object,
  selected: PropTypes.bool,
  type: PropTypes.string,
};

export default TopicOptionB;
